import { BaseModal } from './BaseModal'

interface Props {
  isOpen: boolean
  onGoToDaily: () => void
  onStayHere: () => void
}

export const DailyGamePromptModal = ({
  isOpen,
  onGoToDaily,
  onStayHere,
}: Props) => {
  return (
    <BaseModal
      title="Napi feladvány"
      isOpen={isOpen}
      handleClose={onStayHere}
      preventBackdropClose={true}
      zIndex={1025}
    >
      <div className="mt-4 space-y-4">
        <p className="text-gray-700 dark:text-gray-300">
          Úgy tűnik, hogy nem a mai napi feladványon játszol.
        </p>
        <p className="text-gray-600 dark:text-gray-400 text-sm">
          A ranglistára csak a napi feladvány számít. Szeretnél a mai napra
          ugrani?
        </p>
        <div className="flex gap-3 mt-6">
          <button
            onClick={onStayHere}
            className="flex-1 px-4 py-2 bg-gray-200 dark:bg-gray-600 text-gray-800 dark:text-gray-200 rounded-md hover:bg-gray-300 dark:hover:bg-gray-500"
          >
            Maradok itt
          </button>
          <button
            onClick={onGoToDaily}
            className="flex-1 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
          >
            Mai napra
          </button>
        </div>
      </div>
    </BaseModal>
  )
}
